
    <div [ngClass]="{'checkbox-inline': inline, 'checkbox': !inline}" *ngFor="let item of options"><label><input #checkbox type="checkbox" [checked]="isChecked(item)" [disabled]="isDisabled(item)" (change)="onCheckBoxChange(item, checkbox)">{{formatter(item)}}</label></div>
  